import { OrderedSet } from "immutable";
import { ContentBlock, EntityInstance } from "draft-js";
import { ExtendedRichUtils, ALIGNMENTS } from '../../../ui-components/richTextEditor/utility/extendedRichUtils';

export const getFullHtml = (source: string) => {
    const style = `
    <style>
        .editor_content p { margin:0px }
        .editor_content figure { margin:0px }
        .editor_content p span { font-size:16px }

    </style>
    <div class='editor_content'>
    `
    const close = `</div>`
    return style + source + close;
}
export const getEditorOptions = () => {
    return {
        inlineStyleFn: (styles) => {
            return getStyle(styles);
        },
        blockStyleFn: (block: ContentBlock) => {
            return getBlockTypeStyle(block);
        },
        entityStyleFn: (entity: EntityInstance) => {
            return getEntityStyle(entity)
        }
    }
}
const getStyle = (styles: OrderedSet<any>) => {
    const color = getColorStyle(styles);
    const fontStyle = getFontStyle(styles);
    const ret = {
        style: {
            ...styles.toObject(),
            ...color,
            ...fontStyle,
        }
    }
    return ret;
}
const getEntityStyle = (entity: EntityInstance) => {
    const entityType = entity.getType().toLowerCase();
    switch (entityType) {
        case 'image':
            const data = entity.getData();
            var style = {
                element: 'img',
                attributes: {
                    src: data.src,
                },
                style: {
                    width: (data.width || 100) + '%'
                }
            }
            if (data.alignment) {
                if (data.alignment === 'center') {
                    style.style['margin-left'] = 'auto';
                    style.style['margin-right'] = 'auto';
                    style.style['display'] = 'block';
                }
                else if (data.alignment === 'right') {
                    style.style['float'] = 'right';
                    style.style['position'] = 'relative';
                }
                else if (data.alignment === 'left') {
                    style.style['float'] = 'left';
                    style.style['position'] = 'relative';
                }
                else if (data.alignment === 'default') {
                    style.style['position'] = 'relative';
                }
            }
            return style;
    }
}
const getBlockTypeStyle = (block: ContentBlock) => {
    const alignment = ExtendedRichUtils.getBlockAlignment(block);
    switch (alignment) {
        case ALIGNMENTS.CENTER:
        case ALIGNMENTS.RIGHT:
        case ALIGNMENTS.LEFT:
        case ALIGNMENTS.JUSTIFY:
            return {
                style: {
                    textAlign: alignment,
                    margin: '0px'
                },
            }
        default:
            return {
                style: {
                    margin: '0px'
                }
            }
    }
}

const getColorStyle = (styles: OrderedSet<any>) => {
    let key = '#';
    let c = styles.filter((value) => value.startsWith(key)).first();
    if (cancelAnimationFrame) {
        return {
            color: c,
        }
    }
}
const getFontStyle = (styles: OrderedSet<any>) => {
    let ret = {};
    const s = styles.toObject();
    if (s['BOLD']) {
        ret['font-weight'] = 'bold';
    }
    if (s['ITALIC']) {
        ret['font-style'] = 'italic';
    }
    if (s['UNDERLINE']) {
        ret['text-decoration'] = 'underline'
    }
    if (s['STRIKETHROUGH']) {
        ret['text-decoration'] = 'line-through'
    }
    if (s['HIGHLIGHT']) {
        ret['background-color'] = '#FFFF00'
    }
    return ret;
}